import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans, withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { withSnackbar } from "notistack";
import CardList from "../../core-elements/CardList";
import ItemRequiredReadingDocument from "../list-item/ItemRequiredReadingDocument";
import FilterWrapper from "../filter/FilterWrapper";

export class DocumentFilterDialog extends Component {
  state = {
    open: true,
    title: "",
    description: "",
    notificationDate: null,
    expiryDate: null,
    activeStep: 0,
    documents: this.props.initialDocuments ? this.props.initialDocuments : [],
    users: [],
    instance: new Date().getTime().toString(),
    teams: [],
    userLists: [],
    teamUsers: [],
    saving: false,
    filters: {
      sort: "createdDate",
      sortDirection: "DESC",
      draft: "Live",
      titleContains: "",
      favourited: false,
      liked: false,
      viewed: false,
      modifiedSinceLastSeen: false,
      onlyCreatedRecently: false,
      modifiedInLast: 0,
      taxonomyDialogOpen: false,
      createdBy: [],
      modifiedBy: [],
      taxonomy: [],
      createdStart: "",
      createdEnd: "",
      modifiedStart: "",
      modifiedEnd: "",
      loadingUsers: false,
    },
    unviewableDocuments: [],
  };

  onFilterChange = (filter) => {
    if (filter.hasOwnProperty("taxonomy") === true) {
      if (
        filter.taxonomy.filter(
          (ele) =>
            ele.type === "taxonomy" &&
            ele.parentList &&
            ele.parentList.length === 0
        ).length > 0
      ) {
        filter.taxonomy = [];
      }
    }
    this.setState({
      filters: filter,
    });
  };

  render() {
    const { classes, t } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        maxWidth={false}
        fullScreen
      >
        <DialogTitle>
          <Trans i18nKey="create_document_portlet" />
        </DialogTitle>
        <DialogContent>
          <FilterWrapper
            asPopper={false}
            open={true}
            filterElement={"FilterDocuments"}
            filter={this.state.filters}
            onFilterChange={this.onFilterChange}
            isFilterBar={false}
            title={this.state.filterTitle}
            showReset={this.state.haveFiltersChanged}
            resetToDefaultFilters={this.resetToDefaultFilters}
            filterInstance={this.state.filterInstance}
            disabledFilters={["draft"]}
          />
          <div
            style={{ marginBottom: 10, height: "100%" }}
            id="required-reading-document-list"
          >
            <CardList
              noIcons
              parameters={this.state.filters}
              listItem={ItemRequiredReadingDocument}
              isPortlet={false}
              selectedDocuments={this.state.documents}
              listOnly
              onItemClick={this.onDocumentSelected}
              portlet={{ id: Math.floor(Math.random() * 1000) + 1 }}
              listItemTitleColumn={{
                name: "title",
                message: "global_document_title",
              }}
              messageType="com.kpsol.api.apicommon.document.DocumentInterface"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color="primary">
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button
            onClick={(e) => {
              this.props.onSubmit(this.state.documents, e);
            }}
            color="primary"
            autoFocus
          >
            <Trans i18nKey="global_add" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  onDocumentSelected = (doc) => {
    if (this.props.singleSelect) {
      this.setState({
        documents: [doc],
      });
      return;
    }
    if (
      this.state.documents.filter((d) => d.documentID === doc.documentID)
        .length === 0
    ) {
      this.setState({ documents: [...this.state.documents, doc] });
    } else {
      this.setState({
        documents: this.state.documents.filter(
          (d) => d.documentID !== doc.documentID
        ),
      });
    }
  };
}

export default withTranslation()(withSnackbar(DocumentFilterDialog));
